import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core'
import Button from '@material-ui/core/Button'
import ClipboardUtil from './ClipboardUtil'
import Snackbar from '@material-ui/core/Snackbar'
import FileCopyIcon from '@material-ui/icons/FileCopy'
/**
 * BoardDefJsonViewer
 */
class BoardDefJsonViewer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      snackOpen: false,
    }
  }
  render() {
    const { open, boardDefs, closeAction } = this.props
    const text = JSON.stringify(boardDefs)
    const closeSnackbar = () => { this.setState({ snackOpen: false }) }
    const openSnackbar = () => { this.setState({ snackOpen: true }) }
    const copy = () => {
      ClipboardUtil.copyTextToClipboard(text)
      openSnackbar()
    }

    return (
      <div>
        <Dialog
          open={open || false}
          onClose={closeAction}
          maxWidth='md'
        >
          <DialogTitle>Board Definitions JSON</DialogTitle>
          <DialogContent>
            <DialogContentText name='json-view' rows={20}>
              { text }
            </DialogContentText>
          </DialogContent>
          <DialogActions>

            <Button color='primary' onClick={copy}>
              <FileCopyIcon /> Copy To Clipboard
            </Button>
            <Button color='primary' onClick={closeAction}>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          open={this.state.snackOpen}
          message='Copied to Clipboard!'
          onClose={() => closeSnackbar()}
          />
      </div>
    )
  }
}

BoardDefJsonViewer.propTypes = {
  open: PropTypes.bool,
  closeAction: PropTypes.func.isRequired,
  boardDefs: PropTypes.array
}

export default BoardDefJsonViewer



// WEBPACK FOOTER //
// ./src/routes/BoardDefsEditor/components/BoardDefJsonViewer.js